(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["how-to-use-section"]) return;
  try {
    
let readMore = document.getElementById('howtouse_read-more')
let readLess = document.getElementById('howtouse_read-less');
let truncatedContent = document.getElementById('truncated-howtouse-description');
let fullContent = document.getElementById('howtouse-description');

readMore.addEventListener('click', showHideDescription)
readLess.addEventListener('click', showHideDescription)

function showHideDescription(){
  let ID = this.id
  if(ID === "howtouse_read-more"){
    truncatedContent.style.display = "none";
    fullContent.style.display = "block";
  }else {
    truncatedContent.style.display = "block";
    fullContent.style.display = "none";    
  }
}

  } catch(e) { console.error(e); }
})();
})();
